import React from "react";
import Container from "@material-ui/core/Container";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";
import PublicTrackingLayout from "../layouts/PublicTrackingLayout";
import PublicTrackingSearchResultComponents
    from "../components/public-tracking-page/PublicTrackingSearchResultComponents";
import queryString from 'query-string';
import PublicTrackingInfoComponents from "../components/public-tracking-page/PublicTrackingInfoComponents";
import {getDomain} from "../api/BackendRestClient";
import {VCPPublicTrackingSearchResultComponents} from "../components/public-tracking-page/VCPPublicTrackingSearchResultComponents";

const PublicTrackingPage = () => {

    const location = useLocation();
    
    const {search} = queryString.parse(location.search) as {
                        search?: string;
                    };

    const {t} = useTranslation();


    return (<>

            <Helmet>
                <title>{t("page.title.public-tracking")}</title>
                <meta name="description" content={t("page.title.public-tracking")}/>
            </Helmet>

            <PublicTrackingLayout pageTitle={t("page.title.public-tracking")}>
                <Container>
                    {search ?
                        <DomainSpecificResultComponents search={search}/>
                        :
                        <PublicTrackingInfoComponents/>
                    }
                </Container>
            </PublicTrackingLayout>
        </>
    );

};

const DomainSpecificResultComponents: React.FC<{ search: string }> = ({search}) => {
    const domain = getDomain();

    if (domain === "VCP") {
        return <VCPPublicTrackingSearchResultComponents search={search}/>
    }
    return <PublicTrackingSearchResultComponents search={search}/>
}


export default PublicTrackingPage;

